import * as React from 'react';

export function IconDawndusk(): JSX.Element {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             width="34"
             height="34"
             viewBox="0 0 34 34">
            <line x1="16.947"
                  y1="5.613"
                  x2="16.947"
                  y2="9.364"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="28.278"
                  y1="16.94"
                  x2="24.527"
                  y2="16.94"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="5.611"
                  y1="16.94"
                  x2="9.363"
                  y2="16.94"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="24.951"
                  y1="8.926"
                  x2="22.299"
                  y2="11.579"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="8.923"
                  y1="8.936"
                  x2="11.575"
                  y2="11.588"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M22.484,18.135a5.667,5.667,0,1,0-11.079,0Z"
                  fill="#f7c300"/>
            <line x1="2.781"
                  y1="18.433"
                  x2="31.114"
                  y2="18.433"
                  fill="none"
                  stroke="#a9a9a9"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    );
}
